import React from 'react';
import { Inbox } from './index';

export default (): React.ReactElement => {
    return <Inbox />;
};


export const src = "import React from 'react';\nimport { Inbox } from './index';\n\nexport default (): React.ReactElement => {\n    return <Inbox />;\n};\n";